import { FormRowData } from '@store';

export const extractFormIds = (formList: FormRowData[], filterFn?: (item: FormRowData) => boolean): string[] => {
  if (!Array.isArray(formList)) {
    console.warn('getSelectableIds: formList is not an array');
    return [];
  }

  if (formList.length === 0) {
    return [];
  }

  if (!filterFn) {
    return formList.map((item) => String(item.id));
  }

  const result: string[] = [];
  for (const item of formList) {
    if (filterFn(item)) {
      result.push(String(item.id));
    }
  }

  return result;
};
